// PurchaseInsightsWidget — Dashboard'da satın alma genel analitiği.
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { fmtAmount } from '../utils/numberFormat';

export default function PurchaseInsightsWidget({ onNavigate }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/purchase-insights/dashboard', { params: { period_months: 12 } })
      .then(r => { if (r.data?.success) setData(r.data.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={S.wrap}><div style={S.title}>🛒 Satın Alma Özeti</div>
      <div style={{ padding: 12, color: 'var(--text-tertiary)', fontSize: 'var(--text-sm)' }}>Yükleniyor...</div>
    </div>
  );

  if (!data || !data.summary || !data.summary.total_invoices) {
    return (
      <div style={S.wrap}><div style={S.title}>🛒 Satın Alma Özeti</div>
        <div style={{ padding: 14, color: 'var(--text-tertiary)', fontSize: 'var(--text-sm)', textAlign: 'center' }}>
          Son 12 ayda alış faturası yok.
        </div>
      </div>
    );
  }

  const maxVendorAmt = data.topVendors[0]?.total_amount || 1;

  return (
    <div style={S.wrap}>
      <div style={S.title}>
        🛒 Satın Alma Özeti — Son 12 Ay
        {onNavigate && (
          <button onClick={() => onNavigate('reorder-suggestions')} style={S.openBtn}>Sipariş Önerileri →</button>
        )}
      </div>

      <div style={S.summary}>
        <div style={S.summaryCell}>
          <div style={S.summaryLabel}>Fatura</div>
          <div style={S.summaryValue}>{data.summary.total_invoices}</div>
        </div>
        <div style={S.summaryCell}>
          <div style={S.summaryLabel}>Toplam</div>
          <div style={{ ...S.summaryValue, color: 'var(--accent-primary)' }}>{fmtAmount(data.summary.total_amount)} ₺</div>
        </div>
        <div style={{ ...S.summaryCell, borderRight: 'none' }}>
          <div style={S.summaryLabel}>Tedarikçi</div>
          <div style={S.summaryValue}>{data.summary.vendor_count}</div>
        </div>
      </div>

      <div style={{ fontSize: 'var(--text-xs)', fontWeight: 700, textTransform: 'uppercase', color: 'var(--text-tertiary)', marginBottom: 8 }}>
        🏆 En Çok Alım Yapılan 5 Tedarikçi
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {data.topVendors.slice(0, 5).map(v => {
          const pct = (parseFloat(v.total_amount) / maxVendorAmt) * 100;
          return (
            <div key={v.id}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--text-xs)', marginBottom: 2 }}>
                <span style={{ color: 'var(--text-primary)', fontWeight: 600 }}>{v.title}</span>
                <span style={{ color: 'var(--text-secondary)' }}>
                  {v.invoice_count} fatura · <strong style={{ color: 'var(--accent-primary)' }}>{fmtAmount(v.total_amount)} ₺</strong>
                </span>
              </div>
              <div style={{ height: 6, background: 'var(--bg-tertiary)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ height: '100%', width: pct + '%', background: 'var(--accent-primary)', opacity: 0.7 }} />
              </div>
            </div>
          );
        })}
      </div>

      {data.categories && data.categories.length > 0 && (
        <>
          <div style={{ fontSize: 'var(--text-xs)', fontWeight: 700, textTransform: 'uppercase', color: 'var(--text-tertiary)', marginTop: 14, marginBottom: 8 }}>
            📦 Kategori Dağılımı (Top 5)
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {data.categories.slice(0, 5).map(c => (
              <div key={c.category_name} style={{ padding: '4px 10px', background: 'var(--bg-tertiary)', borderRadius: 'var(--r-full)', fontSize: 'var(--text-xs)' }}>
                <strong>{c.category_name}</strong> · {fmtAmount(c.total_amount)} ₺
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const S = {
  wrap: {
    background: 'var(--bg-card)',
    border: '1px solid var(--border-secondary)',
    borderRadius: 'var(--r-md)',
    padding: 14,
    boxShadow: 'var(--shadow-xs)',
    margin: '14px 0',
  },
  title: {
    fontSize: 'var(--text-md)', fontWeight: 700, color: 'var(--text-primary)',
    marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  openBtn: {
    background: 'transparent', border: 'none', color: 'var(--accent-primary)',
    fontSize: 'var(--text-xs)', fontWeight: 600, cursor: 'pointer',
  },
  summary: {
    display: 'flex', background: 'var(--bg-tertiary)', borderRadius: 'var(--r-md)',
    padding: 10, marginBottom: 14,
  },
  summaryCell: { flex: 1, textAlign: 'center', borderRight: '1px solid var(--border-secondary)', padding: '0 8px' },
  summaryLabel: { fontSize: '0.65rem', color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 700, marginBottom: 4 },
  summaryValue: { fontSize: 'var(--text-lg)', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'JetBrains Mono, monospace' },
};
